(() => {
  'use strict';
  const appKey = Symbol.for('pageone.app');
  if (window[appKey]) return;
  window[appKey] = true;

  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = matchMedia('(hover: hover) and (pointer: fine)');
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];

  // Dynamic Hero Viewport Height Calculation
  // Keeps hero section extending to the exact bottom edge of the viewport
  function syncHeroHeight() {
    if(document.body.classList.contains('po-scroll-locked'))return;
    const hero = $('.hero');
    if (!hero) return;
    const topOffset = hero.getBoundingClientRect().top + window.scrollY;
    const vh = window.innerHeight;
    const exactHeroH = Math.max(380, Math.round(vh - topOffset));
    document.documentElement.style.setProperty('--hero-dynamic-height', exactHeroH + 'px');
    document.documentElement.style.setProperty('--hero-top-offset', Math.round(topOffset) + 'px');
  }
  syncHeroHeight();
  window.addEventListener('resize', () => requestAnimationFrame(syncHeroHeight), { passive: true });
  window.addEventListener('orientationchange', () => setTimeout(syncHeroHeight, 150), { passive: true });
  document.addEventListener('DOMContentLoaded', syncHeroHeight);

  const text = (tag, value, className) => { const e = document.createElement(tag); e.textContent = value; if (className) e.className = className; return e; };
  const storeKey = 'pageone-quote-shortlist-v1';
  let list = [];
  try { const saved = JSON.parse(localStorage.getItem(storeKey) || '[]'); if (Array.isArray(saved)) list = saved.filter(x => typeof x.title === 'string').map(x => ({title:x.title,quantity:String(x.quantity??''),palette:String(x.palette||''),finish:String(x.finish||'')})); } catch {}
  const cards = () => $$('.product-card[data-title]');
  const catalog = () => cards().map(card => ({title:card.dataset.title,kind:card.dataset.kind,description:card.dataset.specs || $('.po-pdp-description',card)?.textContent || '',variants:card.dataset.variants || $$('[data-product-variant] option',card).map(e=>e.textContent).join(' '),specs:card.dataset.specs || $('.product-specs',card)?.textContent || '',price:card.dataset.price || $('.catalog-price',card)?.textContent?.trim() || '',url:card.dataset.url || '',unit:card.dataset.unit || (card.dataset.kind==='Combos'?'sets':'units'),image:$('.product-image img',card)?.src || '',dialog:$('dialog',card)?.id}));
  const normalizeSearch = value => value.toLocaleLowerCase().replace(/grey/g,'gray').replace(/[^\p{L}\p{N}]+/gu,' ').trim();
  const validQuantity = value => /^\d+$/.test(String(value)) && Number(value)>=1 && Number(value)<=1000000;
  const itemUnit = item => item.unit || catalog().find(p=>p.title===item.title)?.unit || 'units';
  const itemLine = item => `${item.title}: approximately ${item.quantity} ${itemUnit(item)}${[item.palette,item.finish].filter(Boolean).length?' · '+[item.palette,item.finish].filter(Boolean).join(' · '):''}`;
  let quoteContext={mode:'single',product:'',quantity:'',branding:'',items:[],generatedMessage:''};
  const ownedMessages=new WeakMap();
  function setQuoteContext(next) {
    const previous=quoteContext;
    quoteContext={mode:'single',product:'',quantity:'',branding:'',items:[],generatedMessage:'',...next};
    ['#PageOneQuote','#PageOneQuoteModalForm'].forEach(id=>{
      const form=$(id);if(!form)return;
      const values={product:quoteContext.product,quantity:quoteContext.quantity,branding:quoteContext.branding};
      Object.entries(values).forEach(([name,value])=>{
        const field=$(`[name="contact[${name}]"]`,form)||$(`[id$="${name[0].toUpperCase()+name.slice(1)}"]`,form);
        if(!field)return;
        if(field.tagName==='SELECT' && value && ![...field.options].some(o=>o.value===value))field.add(new Option(value,value));
        field.value=value;
      });
      let hidden=$('[name="contact[shortlist]"]',form);
      if(!hidden){hidden=document.createElement('input');hidden.type='hidden';hidden.name='contact[shortlist]';form.append(hidden);}
      hidden.value=quoteContext.mode==='shortlist'?quoteContext.items.map(itemLine).join('\n'):'';
      const message=$('[name="contact[body]"]',form)||$('textarea',form);
      if(message){
        let free=message.value;
        const old=ownedMessages.get(message)||previous.generatedMessage;
        if(old && free.includes(old))free=free.replace(old,'').replace(/\n{3,}/g,'\n\n').trim();
        message.value=free+(free&&quoteContext.generatedMessage?'\n\n':'')+quoteContext.generatedMessage;
        ownedMessages.set(message,quoteContext.generatedMessage);
      }
    });
    document.dispatchEvent(new CustomEvent('pageone:quote-context',{detail:structuredClone(quoteContext)}));
  }
  window.PageOneQuote={getContext:()=>structuredClone(quoteContext),setContext:setQuoteContext};
  const announce = value => { const e = $('[data-global-status]'); if (e) e.textContent = value; };
  let panel = null, panelTrigger = null;
  const inertStates = new Map();
  function setPageInert(value) {
    const headerWrapper = $('[data-pageone-header]')?.closest('.shopify-section') || $('[data-pageone-header]');
    [...document.body.children].forEach(e => {
      if (e === headerWrapper || e.contains($('[data-pageone-header]')) || e.tagName === 'DIALOG' || ['SCRIPT','STYLE','LINK'].includes(e.tagName)) return;
      if(value){if(!inertStates.has(e))inertStates.set(e,e.inert);e.inert=true;} else if(inertStates.has(e)){e.inert=inertStates.get(e);}
    });
    if(!value)inertStates.clear();
  }
  let panelClosing = false, panelRevision = 0;
  const panelMotions = new Map();
  function panelMotion(element, opening, backdrop = false) {
    const current = getComputedStyle(element);
    const previous = panelMotions.get(element);
    const from = previous ? { opacity: current.opacity, transform: current.transform, clipPath: current.clipPath }
      : { opacity: opening ? 0 : 1, transform: backdrop ? 'none' : opening ? 'translateY(-14px)' : 'none', clipPath: backdrop ? 'none' : opening ? 'inset(0 0 100% 0 round 24px)' : 'inset(0 0 0 0 round 24px)' };
    previous?.cancel();
    const to = { opacity: opening ? 1 : 0, transform: backdrop ? 'none' : opening ? 'none' : 'translateY(-14px)', clipPath: backdrop ? 'none' : opening ? 'inset(0 0 0 0 round 24px)' : 'inset(0 0 100% 0 round 24px)' };
    const animation = element.animate([from, to], { duration: reduce.matches ? 0 : opening ? 420 : 360, easing: 'cubic-bezier(.22,.68,0,1)', fill: 'both' });
    panelMotions.set(element, animation);
    return animation;
  }
  function closePanel(returnFocus = true, afterClose = null) {
    if (!panel) { afterClose?.(); return; }
    const revision = ++panelRevision;
    const element = panel === 'menu' ? $('#PageOneMenu') : $('#PageOneSearch');
    const backdrop = $('[data-panel-backdrop]');
    panelClosing = true;
    element.inert = true;
    element.setAttribute('data-panel-closing', '');
    $('[data-menu-toggle]').setAttribute('aria-expanded','false');
    $('[data-menu-toggle]').setAttribute('aria-label','Open menu');
    $('[data-search-toggle]').setAttribute('aria-expanded','false');
    if(returnFocus)panelTrigger?.focus({preventScroll:true});
    const finish = () => {
      if (revision !== panelRevision) return;
      $('#PageOneMenu').hidden = true; $('#PageOneSearch').hidden = true;
      backdrop.hidden = true;
      panelMotions.forEach(animation => animation.cancel()); panelMotions.clear();
      element.inert = false; element.removeAttribute('data-panel-closing');
      document.body.classList.remove('po-overlay-open');
      setPageInert(false); panel = null; panelClosing = false;
      if(afterClose)requestAnimationFrame(afterClose);
    };
    if ((!returnFocus && !afterClose) || reduce.matches) { finish(); return; }
    panelMotion(backdrop, false, true);
    panelMotion(element, false).finished.then(finish).catch(()=>{});
  }
  function openPanel(name, trigger) {
    if (panel === name && !panelClosing) {closePanel();return;}
    if (panel !== name) closePanel(false);
    ++panelRevision; panelClosing = false; panel = name; panelTrigger = trigger;
    const header = $('[data-pageone-header]'); const bounds=header.getBoundingClientRect();
    document.documentElement.style.setProperty('--po-panel-top',bounds.bottom+'px');
    $('#PageOneMenu').hidden = name !== 'menu'; $('#PageOneSearch').hidden = name !== 'search';
    const element = name === 'menu' ? $('#PageOneMenu') : $('#PageOneSearch');
    element.inert = false; element.removeAttribute('data-panel-closing');
    const backdrop = $('[data-panel-backdrop]'); backdrop.hidden = false;
    $('[data-menu-toggle]').setAttribute('aria-expanded',String(name === 'menu'));
    $('[data-menu-toggle]').setAttribute('aria-label', name === 'menu' ? 'Close menu' : 'Open menu');
    $('[data-search-toggle]').setAttribute('aria-expanded',String(name === 'search'));
    document.body.classList.add('po-overlay-open'); setPageInert(true);
    panelMotion(backdrop, true, true);
    const animation = panelMotion(element, true);
    animation.finished.then(()=>{
      if(panelMotions.get(element)!==animation)return;
      animation.cancel();panelMotions.delete(element);
      const backgroundAnimation=panelMotions.get(backdrop);
      backgroundAnimation?.cancel();panelMotions.delete(backdrop);
    }).catch(()=>{});
    if(name==='search') {renderSearch();$('#PageOneSearchInput').focus({preventScroll:true});}
    else $('#PageOneMenu a')?.focus({preventScroll:true});
  }
  let productTrigger = null;
  function openProduct(id, focusTarget = 'h2') {
    const dialog = document.getElementById(id);
    if (!dialog?.matches('.product-dialog')) return;
    const previous = $('.product-dialog[open]');
    if (!previous) productTrigger = panel==='search' ? $('[data-search-toggle]') : document.activeElement;
    closePanel(false);
    if (previous === dialog) return;
    previous?.close('switch');
    const switcher=$('[data-product-switch]',dialog);if(switcher)switcher.value=dialog.id;
    dialog.showModal();
    $('.po-pdp-body', dialog)?.scrollTo({top:0,behavior:'instant'});
    requestAnimationFrame(() => $(focusTarget, dialog)?.focus({preventScroll:true}));
    announce(dialog.dataset.productTitle + ' product details');
  }
  $$('.product-dialog').forEach(dialog => {
    dialog.addEventListener('close', () => {
      if (dialog.returnValue !== 'switch') { const target=productTrigger?.isConnected && !productTrigger.closest('[hidden]') ? productTrigger : $('[data-search-toggle]');target?.focus({preventScroll:true}); }
      dialog.returnValue = '';
    });
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-product-switch]')) openProduct(event.target.value, '[data-product-switch]');
  });
  function renderSearch() {
    const results=$('[data-search-results]');if(!results)return;
    const query=normalizeSearch($('#PageOneSearchInput')?.value||'');
    const found=catalog().filter(p=>query.split(' ').every(term=>normalizeSearch([p.title,p.kind,p.description,p.variants,p.specs].join(' ')).includes(term)));
    results.replaceChildren();
    found.forEach(p=>{
      const button=text('button','');button.type='button';button.dataset.openProduct=p.dialog;
      const image=document.createElement('img');image.src=p.image;image.alt='';image.width=48;image.height=60;image.loading='lazy';const copy=text('span','');copy.append(text('strong',p.title),text('small',[p.kind,p.specs.split('|').slice(0,2).join(' · '),p.price?`₹${p.price} per ${p.unit==='sets'?'set':'unit'} · catalogue reference`:''].filter(Boolean).join(' · ')));button.append(image,copy);results.append(button);
    });
    $('[data-search-empty]').hidden=found.length>0;
  }
  function renderList() {
    const items=$('[data-shortlist-items]');if(!items)return;
    const entries=catalog();list=list.filter(x=>entries.some(p=>p.title===x.title));
    items.replaceChildren();
    list.forEach((item,index)=>{
      const p=entries.find(x=>x.title===item.title);
      const row=text('article','', 'shortlist-row');
      const img=document.createElement('img');img.src=p.image;img.alt=p.title;
      const copy=text('div','');copy.append(text('h3',p.title));
      if(item.palette||item.finish)copy.append(text('p',[item.palette,item.finish].filter(Boolean).join(' · ')));
      const id='ShortlistQuantity'+index;const label=text('label','Approximate quantity ('+itemUnit(item)+')');label.htmlFor=id;
      const input=document.createElement('input');input.id=id;input.type='number';input.min='1';input.max='1000000';input.step='1';input.inputMode='numeric';input.value=item.quantity;input.dataset.shortlistQuantity=item.title;
      const error=text('p','Enter a whole number between 1 and 1,000,000.','shortlist-row-error');error.id=id+'Error';error.hidden=true;input.setAttribute('aria-describedby',error.id);copy.append(label,input,error);
      const remove=text('button','×');remove.type='button';remove.dataset.removeQuote=item.title;remove.setAttribute('aria-label','Remove '+item.title);
      row.append(img,copy,remove);items.append(row);
    });
    $$('[data-quote-count]').forEach(e=>e.textContent=String(list.length));
    $('[data-shortlist-empty]').hidden=list.length>0;
    $('[data-shortlist-enquire]').disabled=list.length===0;
    $$('[data-add-quote]').forEach(button=>{const added=list.some(p=>p.title===button.dataset.addQuote);button.classList.toggle('is-added',added);button.setAttribute('aria-pressed',String(added));button.setAttribute('aria-label',added?'Review shortlist: '+button.dataset.addQuote:'Add to shortlist: '+button.dataset.addQuote);button.replaceChildren(text('span',added?'✓':'+'),document.createTextNode(added?' Added · Review shortlist':' Add to quote'));});
  }
  function saveList(){try{localStorage.setItem(storeKey,JSON.stringify(list));}catch{}renderList();}

  // Mobile touch pagination dots for product catalog rail
  function updateProductDots() {
    const container = $('[data-product-dots]');
    const grid = $('.product-grid');
    if (!container || !grid) return;
    const visibleCards = cards().filter(c => !c.hidden);
    if (visibleCards.length <= 1 || grid.scrollWidth <= grid.clientWidth + 1) { container.innerHTML = ''; return; }
    
    // Ensure correct number of dots
    if (container.children.length !== visibleCards.length) {
      container.replaceChildren();
      visibleCards.forEach((c, idx) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'home-carousel-dot' + (idx === 0 ? ' active' : '');
        dot.setAttribute('aria-label', 'Go to ' + (c.dataset.title || ('item ' + (idx + 1))));
        dot.setAttribute('aria-current', String(idx === 0));
        dot.addEventListener('click', () => {
          c.scrollIntoView({ behavior: reduce.matches ? 'instant' : 'smooth', block: 'nearest', inline: 'start' });
        });
        container.append(dot);
      });
    }

    // Determine currently active card based on scrollLeft
    const gridRect = grid.getBoundingClientRect();
    let minDiff = Infinity, activeIdx = 0;
    visibleCards.forEach((c, idx) => {
      const cRect = c.getBoundingClientRect();
      const diff = Math.abs(cRect.left - gridRect.left);
      if (diff < minDiff) { minDiff = diff; activeIdx = idx; }
    });
    [...container.children].forEach((dot, idx) => {
      const isCur = idx === activeIdx;
      dot.classList.toggle('active', isCur);
      dot.setAttribute('aria-current', String(isCur));
    });
  }

  const gridEl = $('.product-grid');
  if (gridEl) {
    gridEl.addEventListener('scroll', () => {
      requestAnimationFrame(updateProductDots);
    }, { passive: true });
  }

  updateProductDots();
  renderList();
  function openList(){closePanel(false);renderList();const d=$('#PageOneShortlist');if(d&&!d.open)d.showModal();}
  function chooseProduct(title, variant = '', quantity = '') {
    setQuoteContext({mode:'single',product:title,quantity,branding:variant,items:[]});
  }
  function validateList() {
    const invalid=$$('[data-shortlist-quantity]').filter(input=>!validQuantity(input.value));
    $$('[data-shortlist-quantity]').forEach(input=>{const bad=invalid.includes(input);input.setAttribute('aria-invalid',String(bad));const error=document.getElementById(input.getAttribute('aria-describedby'));if(error)error.hidden=!bad;});
    if(invalid.length){announce('Check each shortlist quantity. Enter whole numbers from 1 to 1,000,000.');invalid[0].focus();return false;}return list.length>0;
  }
  function configuredItem(dialog,title){return {title,quantity:$('[data-product-quantity]',dialog)?.value||'',palette:$('[data-product-variant]',dialog)?.value||'',finish:$('[data-product-finish][aria-pressed="true"]',dialog)?.dataset.productFinish||'',unit:catalog().find(p=>p.title===title)?.unit||'units'};}
  function browseCollection(){ $('#PageOneShortlist')?.close();const section=$('#collection');section?.scrollIntoView({behavior:reduce.matches?'instant':'smooth'});const heading=$('h2',section||document);heading?.setAttribute('tabindex','-1');heading?.focus({preventScroll:true}); }
  function openQuoteModal(title, variant, quantity) {
    closePanel(false);
    if (title) chooseProduct(title, variant, quantity);
    if (matchMedia('(max-width: 760px)').matches && $('#PageOneQuote')) {
      document.dispatchEvent(new CustomEvent('pageone:open-inline-quote'));
      return;
    }
    const d = $('#PageOneQuoteModal');
    if (d && !d.open) {
      d.showModal();
      requestAnimationFrame(() => $('#ModalQuoteName')?.focus({preventScroll:true}));
    }
  }
  function applyFilter(category) {
    let count=0;
    cards().forEach(card=>{card.hidden=category==='gifts'?card.dataset.kind!=='Combos':category!=='all'&&card.dataset.kind!==category;if(!card.hidden)count++;});
    $$('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.filter===category)));
    $$('[data-result-count]').forEach(e=>e.textContent=String(count));
    const empty=$('.filter-empty');if(empty)empty.hidden=count>0;
    $('.product-grid')?.scrollTo({left:0,behavior:'instant'}); updateProductDots();
  }
  document.addEventListener('click', event=>{
    const target=event.target.closest('button,a,[data-panel-backdrop]');if(!target)return;
    if(target.matches('[data-menu-toggle]'))openPanel('menu',target);
    else if(target.matches('[data-search-toggle]'))openPanel('search',target);
    else if(target.matches('[data-panel-backdrop]'))closePanel();
    else if(target.matches('[data-clear-search]')){$('#PageOneSearchInput').value='';renderSearch();$('#PageOneSearchInput').focus();}
    else if(target.matches('[data-open-product]')){event.preventDefault();openProduct(target.dataset.openProduct);}
    else if(target.matches('[data-product-step]')){
      const dialogs=$$('.product-dialog'); const index=dialogs.indexOf(target.closest('dialog'));
      const step=Number(target.dataset.productStep);
      openProduct(dialogs[(index+step+dialogs.length)%dialogs.length].id, '[data-product-step="'+step+'"]');
    }
    else if(target.matches('[data-product-finish]')){
      $$('[data-product-finish]',target.closest('dialog')).forEach(button=>button.setAttribute('aria-pressed',String(button===target)));const finishFigure=$('[data-finish-images]',target.closest('dialog')),finishImage=finishFigure&&$('img',finishFigure);if(finishImage){const key={'Foil branding':'foilSrc','Debossed branding':'debossSrc','Printed branding':'printSrc'}[target.dataset.productFinish]||'defaultSrc';if(finishFigure.dataset[key]&&finishImage.getAttribute('src')!==finishFigure.dataset[key]){finishImage.removeAttribute('srcset');finishImage.removeAttribute('sizes');finishImage.src=finishFigure.dataset[key];}}const configured=$('[data-add-configured]',target.closest('dialog'));if(configured){delete configured.dataset.configuredSaved;configured.textContent='Add configuration to shortlist';}
    }
    else if(target.matches('[data-close-dialog]'))target.closest('dialog')?.close();
    else if(target.matches('[data-open-shortlist]'))openList();
    else if(target.matches('[data-add-configured]')){
      const dialog=target.closest('.product-dialog'),item=configuredItem(dialog,dialog.dataset.productTitle);
      const quantity=$('[data-product-quantity]',dialog);
      if(!validQuantity(item.quantity)){$('[data-product-error]',dialog).hidden=false;quantity.focus();return;}
      const existing=list.findIndex(p=>p.title===item.title);
      if(target.dataset.configuredSaved==='true' && existing>=0 && JSON.stringify(list[existing])===JSON.stringify(item)){dialog.close('switch');openList();return;}
      if(existing>=0)list[existing]=item;else list.push(item);
      saveList();announce(item.title+' configuration saved to your shortlist.');
      target.textContent='Configuration saved · Review shortlist';target.dataset.configuredSaved='true';
    }
    else if(target.matches('[data-add-quote]')){
      const title=target.dataset.addQuote;if(list.some(p=>p.title===title)){openList();return;}
      list.push({title,quantity:'1',palette:'',finish:'',unit:catalog().find(p=>p.title===title)?.unit||'units'});
      saveList();announce(title+' added to your quote shortlist. Continue browsing or review your shortlist from the navigation.');
    }
    else if(target.matches('[data-remove-quote]')){
      const index=list.findIndex(p=>p.title===target.dataset.removeQuote);list=list.filter(p=>p.title!==target.dataset.removeQuote);saveList();
      const next=$$('[data-remove-quote]')[Math.min(index,list.length-1)]||$('[data-browse-shortlist]')||$('[data-close-dialog]',$('#PageOneShortlist'));next?.focus();announce('Piece removed from your shortlist.');
    }
    else if(target.matches('[data-browse-shortlist]'))browseCollection();
    else if(target.matches('[data-copy-shortlist]')){
      if(!validateList())return;
      const summary='Page One shortlist\n'+list.map(item=>{const product=catalog().find(p=>p.title===item.title);return itemLine(item)+'\n'+new URL(product?.url||'/#collection',location.origin).href;}).join('\n\n');
      const fallback=$('[data-shortlist-copy-output]');if(fallback){fallback.value=summary;fallback.hidden=false;}
      if(navigator.clipboard?.writeText)navigator.clipboard.writeText(summary).then(()=>announce('Shortlist copied.')).catch(()=>{fallback?.focus();fallback?.select();announce('Select and copy the shortlist summary below.');});
      else {fallback?.focus();fallback?.select();announce('Select and copy the shortlist summary below.');}
    }
    else if(target.matches('[data-shortlist-enquire]')){
      if(!validateList())return;
      const units=new Set(list.map(itemUnit));
      setQuoteContext({mode:'shortlist',product:list.length===1?list[0].title:'Multiple pieces / quote shortlist',quantity:units.size===1?String(list.reduce((sum,p)=>sum+Number(p.quantity),0)):'',branding:list.length===1?[list[0].palette,list[0].finish].filter(Boolean).join(' · '):'See itemised shortlist',items:list.map(p=>({...p,unit:itemUnit(p)})),generatedMessage:'My Page One quote shortlist:\n'+list.map(itemLine).join('\n')});
      $('#PageOneShortlist').close();openQuoteModal();
    }
    else if(target.matches('[data-filter]'))applyFilter(target.dataset.filter);
    else if(target.matches('[data-show-gifts]')){applyFilter('gifts');$('#collection')?.scrollIntoView({behavior:reduce.matches?'instant':'smooth'});}
    else if(target.matches('[data-quote-product]')){
      event.preventDefault();
      const dialog=target.closest('dialog');
      const quantity=$('[data-product-quantity]',dialog||document);
      if (dialog?.matches('.product-dialog') && quantity && !validQuantity(quantity.value)) {
        $('[data-product-error]',dialog).hidden=false; quantity.focus(); return;
      }
      const palette=dialog ? $('[data-product-variant]',dialog)?.value : $('[data-product-variant]',target.closest('.shopify-product')||document.querySelector('.shopify-product')||document.createElement('div'))?.value;
      const finish=dialog ? $('[data-product-finish][aria-pressed="true"]',dialog)?.dataset.productFinish : undefined;
      const variant=[palette,finish].filter(Boolean).join(' · ');
      const title=target.dataset.quoteProduct;
      if(dialog?.matches('.product-dialog'))$('[data-product-error]',dialog).hidden=true;
      dialog?.close('switch');
      closePanel(false);
      openQuoteModal(title, variant, dialog?.matches('.product-dialog')?quantity?.value||'':'');
    }
    else if(target.closest('#PageOneMenu')) {
      event.preventDefault();
      const destination = new URL(target.href, location.href);
      closePanel(false, () => {
        if(destination.origin===location.origin && destination.pathname===location.pathname && destination.hash) {
          const section=document.getElementById(destination.hash.slice(1));
          section?.scrollIntoView({behavior:reduce.matches?'instant':'smooth'});
          const heading=section?.querySelector('h1,h2') || section;
          heading?.setAttribute('tabindex','-1');heading?.focus({preventScroll:true});
          history.replaceState(null,'',destination.hash);
        } else location.assign(destination.href);
      });
    }
    else if(target.matches('[data-quote-occasion]')){const e=$('#QuoteOccasion');if(e)e.value=target.dataset.quoteOccasion;}
  });
  document.addEventListener('input',event=>{
    if(event.target.matches('[data-catalog-search]'))renderSearch();
    if(event.target.closest('.product-dialog') && event.target.matches('[data-product-quantity],[data-product-variant]')){const button=$('[data-add-configured]',event.target.closest('dialog'));if(button){delete button.dataset.configuredSaved;button.textContent='Add configuration to shortlist';}}
    if(event.target.matches('[data-shortlist-quantity]')){
      const item=list.find(x=>x.title===event.target.dataset.shortlistQuantity);
      if(item){item.quantity=event.target.value;event.target.setAttribute('aria-invalid',String(!validQuantity(event.target.value)));const error=document.getElementById(event.target.getAttribute('aria-describedby'));if(error)error.hidden=validQuantity(event.target.value);try{localStorage.setItem(storeKey,JSON.stringify(list));}catch{}}
    }
  });
  document.addEventListener('keydown',event=>{
    if(!panel)return;
    if(event.key==='Escape'){event.preventDefault();closePanel();}
    if(event.key==='Tab'){
      const visible=$$('a,button,input', $('[data-pageone-header]')).filter(e=>!e.closest('[hidden]')&&e.getClientRects().length&&!e.disabled);
      const first=visible[0],last=visible.at(-1);
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus();}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}
    }
  });
  $$('dialog').forEach(dialog=>dialog.addEventListener('click',e=>{
    if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}
  }));
  renderList();
  // Decode the replacement before atomically swapping the shared gift preview.
  const giftImage=$('[data-gift-image]');let giftRevision=0;
  $$('[data-gift-choice]').forEach(choice=>choice.addEventListener('toggle',()=>{
    if(!choice.open||!giftImage)return;
    const revision=++giftRevision, image=new Image();image.src=choice.dataset.giftSrc;
    const ready=image.decode?image.decode().then(()=>true,()=>image.complete&&image.naturalWidth>0):new Promise(resolve=>{image.onload=()=>resolve(true);image.onerror=()=>resolve(false);if(image.complete)resolve(image.naturalWidth>0);});
    ready.then(ok=>{if(!ok||revision!==giftRevision||!choice.open)return;giftImage.src=image.src;giftImage.alt=choice.dataset.giftAlt;const title=$('[data-gift-title-label]');if(title)title.textContent=choice.dataset.giftTitle;});
  }));
  const revealKey=Symbol.for('pageone.reveals');
  const setupReveals=window[revealKey]||(() => {
    const registered=new WeakSet(), animations=new Map(), waiting=new Set();
    const root=document.documentElement;
    const booted=root.classList.contains('po-motion-boot');
    const ease='cubic-bezier(.16,1,.3,1)';
    root.classList.add('po-motion-ready');
    function finish(el){
      waiting.delete(el);observer?.unobserve(el);
      const animation=animations.get(el);animations.delete(el);
      el.dataset.revealState='revealed';animation?.cancel();
      if(el.matches('.hero-stage'))document.dispatchEvent(new CustomEvent('pageone:hero-ready'));
    }
    function inView(el){const r=el.getBoundingClientRect();return r.bottom>12&&r.top<innerHeight-12;}
    function launch(el,delay){
      if(el.dataset.revealState!=='preparing')return;
      if(reduce.matches||!el.animate||el.contains(document.activeElement)){finish(el);return;}
      const bounds=el.getBoundingClientRect();
      if(bounds.bottom<=0){finish(el);return;}
      if(document.hidden||document.body.classList.contains('po-scroll-locked')||bounds.top>=innerHeight-12||el.closest('[hidden],dialog')){
        el.dataset.revealState='waiting';waiting.add(el);observer?.observe(el);return;
      }
      el.dataset.revealState='revealing';
      el.dataset.revealCount=String(Number(el.dataset.revealCount||0)+1);
      const image=el.dataset.reveal==='image',heading=/heading/.test(el.dataset.reveal);
      const distance=image?32:heading?28:22;
      const animation=el.animate([{opacity:0,translate:`0 ${distance}px`},{opacity:1,translate:'0 0'}],{
        duration:image?760:heading?680:580,delay,easing:ease,fill:'both',id:'pageone-reveal'
      });
      animations.set(el,animation);
      animation.finished.then(()=>{if(animations.get(el)===animation)finish(el);}).catch(()=>{});
    }
    function imageReady(image){
      return new Promise(resolve=>{
        let timer;
        const done=()=>{clearTimeout(timer);image.removeEventListener('load',loaded);image.removeEventListener('error',done);resolve();};
        const loaded=()=>{if(image.decode)image.decode().catch(()=>{}).then(done);else done();};
        timer=setTimeout(done,1600);
        if(image.complete){loaded();return;}
        image.addEventListener('load',loaded,{once:true});image.addEventListener('error',done,{once:true});
      });
    }
    function reveal(el,delay=0){
      if(el.dataset.revealState!=='waiting')return;
      waiting.delete(el);observer?.unobserve(el);el.dataset.revealState='preparing';
      const images=el.matches('img')?[el]:el.matches('.hero-stage')?$$('.hero-slide.is-active img',el):$$('img',el);
      if(images.length&&el.dataset.revealMediaReady!=='true'){
        Promise.all(images.map(imageReady)).then(()=>{el.dataset.revealMediaReady='true';launch(el,delay);});
      }else launch(el,delay);
    }
    const observer='IntersectionObserver' in window?new IntersectionObserver(entries=>{
      let index=0;
      entries.forEach(({target:el,isIntersecting})=>{
        if(!isIntersecting||document.hidden||document.body.classList.contains('po-scroll-locked')||el.closest('[hidden],dialog')||!el.getClientRects().length)return;
        reveal(el,Math.min(index++*35,105));
      });
    },{threshold:.08,rootMargin:'0px 0px -12px 0px'}):null;
    function setupReveals(scope=document){
      const surfaces=$$('main,.quote,.site-footer',scope);
      if(scope.matches?.('main,.quote,.site-footer'))surfaces.push(scope);
      if(!surfaces.length&&scope!==document)surfaces.push(scope);
      surfaces.forEach(surface=>{
        $$('[data-reveal]',surface).forEach(el=>{if(!registered.has(el))el.removeAttribute('data-reveal');});
        const units=$$('h1,h2,h3,p,figure img,figcaption,summary,button,a,ul>li,.form-grid>div,.consent,.captcha-notice,.hero-stage,.product-bottom>span,.footer-bottom>span',surface);
        units.forEach(el=>{
          if(registered.has(el)||el.closest('dialog,.po-ticker,.hero-slides,.hero-carousel-indicators,[aria-hidden="true"]'))return;
          if(el.closest('details')&&!el.matches('summary'))return;
          if(el.matches('[data-preview-feedback]')&&!el.textContent.trim())return;
          if(el.parentElement.closest('[data-reveal]'))return;
          registered.add(el);
          el.dataset.reveal=el.matches('h1,h2')?'heading':el.matches('figure img,.product-image,.hero-stage')?'image':el.matches('summary')?'row':'body';
          el.dataset.revealCount='0';el.dataset.revealState='waiting';waiting.add(el);
          if(reduce.matches||!observer||(!booted&&inView(el)))finish(el);
          else if(el.getBoundingClientRect().bottom<=0)finish(el);
          else observer.observe(el);
        });
      });
    }
    document.addEventListener('focusin',event=>{const unit=event.target.closest('[data-reveal]');if(unit)finish(unit);});
    document.addEventListener('visibilitychange',()=>{
      if(document.hidden){animations.forEach((a,el)=>finish(el));return;}
      waiting.forEach(el=>{if(inView(el)&&!el.closest('[hidden],dialog'))reveal(el);});
    });
    document.addEventListener('pageone:scroll-restored',()=>{
      waiting.forEach(el=>{if(inView(el)&&!el.closest('[hidden],dialog'))reveal(el);});
    });
    reduce.addEventListener('change',()=>{if(reduce.matches){waiting.forEach(finish);$$('[data-reveal-state="preparing"]').forEach(finish);animations.forEach((a,el)=>finish(el));}});
    window[revealKey]=setupReveals;return setupReveals;
  })();
  setupReveals();
  document.documentElement.classList.remove('po-motion-boot');
  // Keep native details semantics and direct answer markup; animate only the changing disclosure.
  const disclosureKey=Symbol.for('pageone.disclosures');
  if(!window[disclosureKey]){
    window[disclosureKey]=true;
    const states=new WeakMap(), active=new Set();
    function settle(detail,state){
      state.animation?.cancel();state.answerAnimations?.forEach(a=>a.cancel());state.animation=null;state.answerAnimations=[];
      detail.open=state.wanted;detail.style.removeProperty('height');detail.style.removeProperty('overflow');
      detail.removeAttribute('data-disclosure-animating');active.delete(detail);
    }
    $$('[data-gift-choice]').forEach(detail=>detail.removeAttribute('name'));
    function changeDisclosure(detail, wanted) {
      const summary=detail.querySelector('summary'),answers=[...detail.children].filter(e=>e!==summary);
      if(!answers.length)return;
      let state=states.get(detail);if(!state){state={wanted:detail.open};states.set(detail,state);}
      const from=detail.getBoundingClientRect().height;
      const opacity=getComputedStyle(answers[0]).opacity;
      state.animation?.cancel();state.answerAnimations?.forEach(a=>a.cancel());state.wanted=wanted;
      if(reduce.matches||!detail.animate){settle(detail,state);return;}
      detail.open=true;detail.style.removeProperty('height');
      const to=state.wanted?detail.getBoundingClientRect().height:summary.getBoundingClientRect().height+parseFloat(getComputedStyle(detail).borderTopWidth||0)+parseFloat(getComputedStyle(detail).borderBottomWidth||0);
      detail.style.height=`${from}px`;detail.style.overflow='clip';detail.dataset.disclosureAnimating='true';active.add(detail);
      const animation=detail.animate([{height:`${from}px`},{height:`${to}px`}],{duration:state.wanted?420:360,easing:'cubic-bezier(.22,.68,0,1)',fill:'forwards'});
      state.animation=animation;
      state.answerAnimations=answers.map(answer=>answer.animate([{opacity:state.wanted?0:opacity,transform:state.wanted?'translateY(-6px)':'none'},{opacity:state.wanted?1:0,transform:state.wanted?'none':'translateY(-6px)'}],{duration:state.wanted?360:280,fill:'forwards',easing:'ease-out'}));
      animation.finished.then(()=>{if(state.animation===animation)settle(detail,state);}).catch(()=>{});
    }
    document.addEventListener('click',event=>{
      const summary=event.target.closest('.faq summary,.po-quality-details summary,[data-gift-choice] summary,.po-pdp-accordions summary');
      if(!summary||event.target.closest('a,input,button,select,textarea'))return;
      const detail=summary.parentElement;
      if(!detail.matches('details'))return;
      event.preventDefault();
      const wanted=!(states.get(detail)?.wanted??detail.open);
      if(wanted && detail.matches('[data-gift-choice]')) {
        $$('[data-gift-choice]').forEach(other=>{
          if(other!==detail && (states.get(other)?.wanted??other.open))changeDisclosure(other,false);
        });
      }
      changeDisclosure(detail,wanted);
    });
    reduce.addEventListener('change',()=>{if(reduce.matches)active.forEach(detail=>settle(detail,states.get(detail)));});
    addEventListener('resize',()=>active.forEach(detail=>settle(detail,states.get(detail))),{passive:true});
  }
  // Carousel pauses offscreen, in a hidden tab, during hover/focus and for reduced motion.
  const slides=$$('[data-hero-slide]');const dots=$$('[data-hero-dot]');const stage=$('.hero-stage');let active=0,timer=null;const pauseReasons=new Set(['entrance']);
  function updateSlide(index){
    if(!slides.length)return;active=(index+slides.length)%slides.length;
    slides.forEach((e,i)=>{e.classList.toggle('is-active',i===active);e.setAttribute('aria-hidden',String(i!==active));});
    dots.forEach((e,i)=>e.setAttribute('aria-pressed',String(i===active)));
    const count=$('[data-hero-count]');
    if(count){count.textContent=String(active+1).padStart(2,'0')+' / '+String(slides.length).padStart(2,'0');count.setAttribute('aria-label','Image '+(active+1)+' of '+slides.length);}
    const progress=$('[data-hero-progress]');if(progress)progress.style.transform='translateX('+(active*100)+'%)';
    slides.forEach((slide,i)=>slide.setAttribute('aria-label',(i+1)+' of '+slides.length+': '+slide.dataset.title));
    const slide=slides[active],tag=$('[data-hero-tag]');
    if(tag){tag.dataset.openProduct=slide.dataset.product;$('[data-hero-title]').textContent=slide.dataset.title;$('[data-hero-note]').textContent=slide.dataset.note;}
  }
  function schedule(){clearInterval(timer);timer=null;if(slides.length>1&&!reduce.matches&&pauseReasons.size===0)timer=setInterval(()=>updateSlide(active+1),3600);}
  function pause(reason,value){value?pauseReasons.add(reason):pauseReasons.delete(reason);schedule();}
  dots.forEach(dot=>dot.addEventListener('click',()=>{updateSlide(Number(dot.dataset.heroDot));schedule();}));
  $('[data-hero-prev]')?.addEventListener('click',()=>{updateSlide(active-1);schedule();});
  $('[data-hero-next]')?.addEventListener('click',()=>{updateSlide(active+1);schedule();});
  $('[data-hero-pause]')?.addEventListener('click',e=>{const manual=!pauseReasons.has('manual');pause('manual',manual);e.currentTarget.setAttribute('aria-label',manual?'Play slideshow':'Pause slideshow');$('.pause-symbol',e.currentTarget).classList.toggle('is-paused',manual);});
  if(stage){
    stage.addEventListener('pointerenter',()=>{if(finePointer.matches)pause('hover',true);});
    stage.addEventListener('pointerleave',()=>pause('hover',false));
    stage.addEventListener('focusin',()=>pause('focus',true));
    stage.addEventListener('focusout',e=>{if(!stage.contains(e.relatedTarget))pause('focus',false);});
    let start=null;
    stage.addEventListener('pointerdown',e=>{
      if(!e.isPrimary||e.button!==0||e.target.closest('button,a'))return;
      start={x:e.clientX,y:e.clientY,id:e.pointerId};
      stage.setPointerCapture(e.pointerId);pause('gesture',true);stage.classList.add('is-dragging');
    });
    const endGesture=e=>{
      if(!start||e.pointerId!==start.id)return;
      const dx=e.clientX-start.x,dy=e.clientY-start.y;
      if(e.type==='pointerup'&&Math.abs(dx)>Math.max(30,stage.clientWidth*.08)&&Math.abs(dx)>Math.abs(dy)*1.25)updateSlide(active+(dx<0?1:-1));
      if(stage.hasPointerCapture(start.id))stage.releasePointerCapture(start.id);
      start=null;stage.classList.remove('is-dragging');pause('gesture',false);
    };
    stage.addEventListener('pointerup',endGesture);
    stage.addEventListener('pointercancel',endGesture);
    stage.addEventListener('lostpointercapture',()=>{start=null;stage.classList.remove('is-dragging');pause('gesture',false);});
    stage.addEventListener('keydown',e=>{if(e.target!==stage||!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;e.preventDefault();updateSlide(e.key==='Home'?0:e.key==='End'?slides.length-1:active+(e.key==='ArrowRight'?1:-1));schedule();});
    if('IntersectionObserver'in window)new IntersectionObserver(entries=>pause('offscreen',!entries[0].isIntersecting),{threshold:.1}).observe(stage);
  }
  updateSlide(0);
  document.addEventListener('pageone:hero-ready',()=>pause('entrance',false),{once:true});
  if(!stage||stage.dataset.revealState==='revealed')pause('entrance',false);
  document.addEventListener('visibilitychange',()=>pause('hidden',document.hidden));pause('hidden',document.hidden);schedule();
  reduce.addEventListener('change',schedule);
  const header=$('[data-pageone-header]');
  let lastScroll=window.scrollY, scrollTravel=0, scrollDirection=0, navFrame=0;
  document.addEventListener('pageone:scroll-restored',event=>{
    lastScroll=event.detail.scrollY;scrollTravel=0;scrollDirection=0;showHeader();
  });
  function showHeader(){if(header){header.classList.remove('is-scroll-hidden');header.inert=false;}}
  function updateHeader(){
    navFrame=0;if(!header)return;
    const y=Math.max(0,Math.min(window.scrollY,document.documentElement.scrollHeight-innerHeight));
    const delta=y-lastScroll;lastScroll=y;
    if(y<80||panel||header.querySelector(':focus-visible')||document.body.classList.contains('po-overlay-open')){
      showHeader();scrollTravel=0;return;
    }
    if(Math.abs(delta)<1)return;
    const direction=Math.sign(delta);
    if(direction!==scrollDirection){scrollTravel=0;scrollDirection=direction;}
    scrollTravel+=Math.abs(delta);
    if(direction<0&&scrollTravel>=10)showHeader();
    else if(direction>0&&scrollTravel>=28){header.classList.add('is-scroll-hidden');header.inert=true;}
  }
  window.addEventListener('scroll',()=>{if(!navFrame)navFrame=requestAnimationFrame(updateHeader);},{passive:true});
  document.addEventListener('keydown',event=>{if(event.key==='Tab')showHeader();});
  header?.addEventListener('focusin',showHeader);
  window.addEventListener('pageshow',()=>{lastScroll=window.scrollY;showHeader();});
  let resizeFrame=0,lastLayoutWidth=innerWidth;window.addEventListener('resize',()=>{cancelAnimationFrame(resizeFrame);resizeFrame=requestAnimationFrame(()=>{if(innerWidth!==lastLayoutWidth){lastLayoutWidth=innerWidth;closePanel(false);showHeader();}});},{passive:true});
  function updateCurrentSection(){
    if(!$('#collection'))return;
    const destinations=new Set($$('[data-nav-section]').map(link=>link.dataset.navSection));const sections=$$('.hero,[data-chapter],#quote').filter(section=>destinations.has(section.id));let current='';
    sections.forEach(section=>{if(section.getBoundingClientRect().top<=innerHeight*.35)current=section.id;});
    $$('.desktop-nav a,#PageOneMenu a').forEach(link=>{const url=new URL(link.href,location.href);if(url.origin!==location.origin||url.pathname!==location.pathname)return;const active=(url.hash.slice(1)||'top')===(current||'top');if(active)link.setAttribute('aria-current','location');else link.removeAttribute('aria-current');});
  }
  let sectionFrame=0;addEventListener('scroll',()=>{if(!sectionFrame)sectionFrame=requestAnimationFrame(()=>{sectionFrame=0;updateCurrentSection();});},{passive:true});updateCurrentSection();
  const d=new Date(),pad=n=>String(n).padStart(2,'0');
  $$('#QuoteDate,#ModalQuoteDate').forEach(date=>{date.min=d.getFullYear()+'-'+pad(d.getMonth()+1)+'-'+pad(d.getDate());});
  const params=new URLSearchParams(location.search);if(params.get('product'))chooseProduct(params.get('product'));
  if(document.body.dataset.localPreview==='true')$$('#PageOneQuote, #PageOneQuoteModalForm').forEach(form=>form.addEventListener('submit',event=>{event.preventDefault();const feedback=$('[data-preview-feedback]',form);if(feedback)feedback.textContent='Preview only: no enquiry has been sent. Call +91 77188 67847 to discuss your requirements.';}));
  document.addEventListener('shopify:section:load',event=>{setupReveals(event.target);renderList();});
})();
